import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  loading: false,
  loaded: false,
  error: null,
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    fetchNavigationRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchNavigationSuccess: (state, action) => {
      state.loading = false;
      state.loaded = true;
      state.error = null;
      state.data = action.payload ?? null;
    },
    fetchNavigationError: (state, action) => {
      state.loading = false;
      state.loaded = false;
      state.error = action.payload || "Failed to fetch navigation";
    },
    clearNavigation: (state) => {
      state.data = null;
      state.loading = false;
      state.loaded = false;
      state.error = null;
    },
  },
});

export const {
  fetchNavigationRequest,
  fetchNavigationSuccess,
  fetchNavigationError,
  clearNavigation,
} = navigationSlice.actions;

export default navigationSlice.reducer;
